<div class="d-flex align-items-end loader-container">
  @if (label()) {
    <div class="d-flex align-items-end mr-1 search-status-text">{{label()}}</div>
  }
  @for (dot of dots(); track $index) {
    {{ '.' }}
  }
</div>
